// Author thq
// Date 2022-04-21 21:31:47

import * as model from "@/model/em/archive/EmEquipmentCategoryModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {levelTreePatternFactory} from "@/store/em/commonPattern/levelTreePatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmEquipmentCategory(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_ARCHIVE_URL,
    })
    .withPatternFactory(levelTreePatternFactory, {
        entity: 'emEquipmentCategory',
        modelFilter: model.filter
    })
    .buildStore()
